import Animate from "../pages/Animate"

const whiteList = new Map([
    ['/animate', <Animate />]
])

export default whiteList